import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '../services/translate.service';
import { UserStore } from '../services/user.store';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaginatorIntlService extends MatPaginatorIntl {
    public translations = {
        tt_pager_first_page: '',
        tt_pager_last_page: '',
        tt_pager_page_size: '',
        tt_pager_next_page: '',
        tt_pager_previous_page: '',
        tt_pager_of: '',
    };

    constructor(
        private translate: TranslateService,
        private user: UserStore,
    ) {
        super();
        this.init();
        this.user.languageIdChanged.subscribe({ next: () => this.init() });
    }

    public override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return '0 ' + this.translations.tt_pager_of + length;
        }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return startIndex + 1 + ' - ' + endIndex + ' ' + this.translations.tt_pager_of + ' ' + length;
    };

    private async init() {
        await this.translateWords();
        this.setLabels();
        this.changes.next();
    }

    private setLabels() {
        this.firstPageLabel = this.translations.tt_pager_first_page;
        this.lastPageLabel = this.translations.tt_pager_last_page;
        this.itemsPerPageLabel = this.translations.tt_pager_page_size;
        this.nextPageLabel = this.translations.tt_pager_next_page;
        this.previousPageLabel = this.translations.tt_pager_previous_page;
    }

    private async translateWords() {
        const response = await this.translate.translateBatch(this.translations);

        for (let k in response) {
            let key = k as keyof typeof this.translations;

            this.translations[key] = response[key];
        }
    }
}
